import { render, staticRenderFns } from "./IdiAdministator.html?vue&type=template&id=6859317a&scoped=true&external"
import script from "./IdiAdministator.vue?vue&type=script&lang=js"
export * from "./IdiAdministator.vue?vue&type=script&lang=js"
import style0 from "./IdiAdministator.scss?vue&type=style&index=0&id=6859317a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6859317a",
  null
  
)

export default component.exports